import 'ui-core/plugins/drawer/js/drawer';
UX.menu.vPort = ['screen-sm'];
UX.menu.on.nested = '';
